<script lang="ts" setup>
import { ref } from "vue"
import { AdjustmentsIcon } from "@heroicons/vue/outline"
import { Slideover } from "@xy-planning-network/trees"
import InitialProps from "@/types/root"
import { Toolbox } from "@/types/toolbox"
import ToolActionSelect from "@/components/tools/ToolActionSelect.vue"

withDefaults(
  defineProps<{
    initialProps: InitialProps
    toolbox?: Toolbox
  }>(),
  {
    toolbox: () => [],
  }
)

const toolboxOpen = ref<boolean>(false)
</script>

<template>
  <div v-if="toolbox.length > 0">
    <button class="xy-btn-neutral w-full" @click="toolboxOpen = !toolboxOpen">
      <div class="flex space-x-1">
        <AdjustmentsIcon class="h-5 w-5 shrink-0" /> <span>Open Toolbox</span>
      </div>
    </button>

    <Slideover
      v-model="toolboxOpen"
      header="Site Testing Tools"
      description="A small set of tools to help you manage the state of this test/demo app."
    >
      <div class="divide-y divide-solid">
        <div v-for="(tool, i) in toolbox" :key="i" class="py-4">
          <h3 class="mb-2">{{ tool.title }}</h3>
          <ToolActionSelect :actions="tool.actions" />
        </div>
      </div>
    </Slideover>
  </div>
</template>
